/**
 * components/topBanner.ts — combien d'espace les bandeaux du haut de l'écran
 * (notification de compte, encart de dispatch avec son décompte…) occupent en
 * ce moment, pour que ce qui reste fixe au même endroit (la bascule jour/nuit)
 * puisse se ranger DESSOUS plutôt que de rester dessus — elle passait
 * systématiquement par-dessus la croix de fermeture des notifications
 * (signalé le 25/08).
 *
 * Plusieurs bandeaux peuvent être présents en même temps ; chacun s'annonce
 * sous sa propre clé, la bascule ne retient que le plus grand des décalages.
 */

let hauteurs = new Map<string, number>();
let ecouteurs: (() => void)[] = [];

export const topBanner = {
  subscribe(cb: () => void) {
    ecouteurs.push(cb);
    return () => { ecouteurs = ecouteurs.filter(e => e !== cb); };
  },
  poser(cle: string, h: number) {
    if (hauteurs.get(cle) === h) return;
    hauteurs = new Map(hauteurs).set(cle, h);
    ecouteurs.forEach(e => e());
  },
  retirer(cle: string) {
    if (!hauteurs.has(cle)) return;
    hauteurs = new Map(hauteurs);
    hauteurs.delete(cle);
    ecouteurs.forEach(e => e());
  },
  lire(): number {
    return hauteurs.size === 0 ? 0 : Math.max(...hauteurs.values());
  },
  serveur: (): number => 0,
};
